import { render } from "./ParallaxHome.vue?vue&type=template&id=f43f3fd0"
import script from "./ParallaxHome.vue?vue&type=script&lang=js"
export * from "./ParallaxHome.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\benme\\Documents\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__